import { IScheduleSupplierContext } from "Interfaces/Providers/Supplier/ScheduleSupplier";
import { ScheduleSupplierContext } from "providers/Supplier/ScheduleSupplierProvider";
import { useContext } from "react";

export default function useScheduleSupplier(): IScheduleSupplierContext {
  const context = useContext(ScheduleSupplierContext);

  return context;
}
